/* KISMET v3 — botón "+" de agregar rápido en tarjetas */
(function () {
function closeAll(except) {
document.querySelectorAll('.card.is-quick').forEach(function (c) { if (c !== except) c.classList.remove('is-quick'); });
}
document.addEventListener('click', function (e) {
var t = e.target.closest('[data-quick-toggle]');
if (t) {
e.preventDefault();
var card = t.closest('.card');
closeAll(card);
card.classList.toggle('is-quick');
return;
}
if (e.target.closest('[data-quick-add]')) {
setTimeout(function () { closeAll(); }, 400);
return;
}
if (!e.target.closest('.card__quick')) closeAll();
});
})();

/* ---------- Barra fija: selector de talla sincronizado ---------- */
(function () {
document.querySelectorAll('[data-product]').forEach(function (root) {
var sel = root.querySelector('[data-sab-size]');
var sizeIdx = parseInt(root.dataset.sizeIndex, 10);
if (!sel || isNaN(sizeIdx) || sizeIdx < 0) return;
var picker = root.querySelector('[data-variant-picker]');
var fs = root.querySelector('.vp__opt[data-option-index="' + sizeIdx + '"]');
function pick(val) {
if (!fs) return;
var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (i) { return i.value === val; });
if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
}
root._kPickSize = pick;
sel.addEventListener('change', function () { if (sel.value) pick(sel.value); });
if (picker) picker.addEventListener('change', function () {
var c = fs && fs.querySelector('input:checked');
if (c && sel.value !== c.value) sel.value = c.value;
});
});
})();

/* ---------- Encuentra tu talla ---------- */
(function () {
var SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
document.querySelectorAll('[data-size-finder]').forEach(function (dlg) {
var root = dlg.closest('[data-product]');
var st = { g: 'h', m: 'body', f: 0, brand: null };
var steps = dlg.querySelectorAll('[data-sf-step]');
var bar = dlg.querySelector('[data-sf-progress]');
var hist = [1];
function show(n) {
steps.forEach(function (s) { s.classList.toggle('is-on', s.dataset.sfStep == n); });
if (bar) bar.style.width = (n / 5 * 100) + '%';
}
function go(n) { hist.push(n); show(n); }
function available() {
var fs = root && root.querySelector('.vp__opt--size');
if (!fs) return SIZES;
return Array.prototype.map.call(fs.querySelectorAll('input'), function (i) { return i.value; });
}
function calc() {
var idx;
if (st.m === 'brand') { idx = st.brand == null ? 2 : st.brand; }
else {
var h = +dlg.querySelector('[data-sf-in="h"]').value, w = +dlg.querySelector('[data-sf-in="w"]').value;
var cuts = st.g === 'm' ? [48, 56, 66, 78, 92] : [55, 64, 76, 88, 102];
idx = 0; while (idx < cuts.length && w > cuts[idx]) idx++;
if (h >= 186) idx++; if (h <= 160) idx--;
if (st.g === 'm') idx--;
}
idx += +st.f;
var avail = available();
var sized = SIZES.filter(function (s) { return avail.indexOf(s) > -1; });
if (!sized.length) sized = avail;
var want = SIZES[Math.max(0, Math.min(SIZES.length - 1, idx))];
if (sized.indexOf(want) === -1) {
var wi = SIZES.indexOf(want), best = sized[0], bd = 99;
sized.forEach(function (s) { var d = Math.abs(SIZES.indexOf(s) - wi); if (d < bd) { bd = d; best = s; } });
want = best;
}
dlg.querySelector('[data-sf-result]').textContent = want;
dlg.querySelector('[data-sf-result-inline]').textContent = want;
dlg.dataset.result = want;
}
dlg.addEventListener('click', function (e) {
var t = e.target.closest('button'); if (!t) return;
if (t.dataset.sfSet) {
st[t.dataset.sfSet] = t.dataset.v;
var cur = +t.closest('[data-sf-step]').dataset.sfStep;
if (t.dataset.sfSet === 'm') {
dlg.querySelector('[data-sf-body]').hidden = st.m !== 'body';
dlg.querySelector('[data-sf-brand]').hidden = st.m !== 'brand';
}
if (cur === 4) { calc(); go(5); } else go(cur + 1);
} else if (t.hasAttribute('data-sf-brand-size')) {
st.brand = +t.dataset.sfBrandSize;
dlg.querySelectorAll('[data-sf-brand-size]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
} else if (t.hasAttribute('data-sf-next')) { go(4); }
else if (t.hasAttribute('data-sf-back')) { hist.pop(); show(hist[hist.length - 1] || 1); }
else if (t.hasAttribute('data-sf-restart')) { hist = [1]; show(1); }
else if (t.hasAttribute('data-sf-apply')) {
if (root && root._kPickSize) root._kPickSize(dlg.dataset.result);
else if (root) {
var inp = Array.prototype.find.call(root.querySelectorAll('.vp__opt--size input'), function (i) { return i.value === dlg.dataset.result; });
if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
}
dlg.close();
} else if (t.dataset.sfTab) {
dlg.querySelectorAll('[data-sf-tab]').forEach(function (b) { b.classList.toggle('is-on', b === t); });
dlg.querySelectorAll('[data-sf-pane]').forEach(function (p) { p.hidden = p.dataset.sfPane !== t.dataset.sfTab; });
}
});
dlg.querySelectorAll('[data-sf-in]').forEach(function (r) {
var out = dlg.querySelector('[data-sf-out="' + r.dataset.sfIn + '"]');
r.addEventListener('input', function () { out.textContent = r.value + (r.dataset.sfIn === 'h' ? ' cm' : ' kg'); });
});
show(1);
});
})();

/* ---------- Transición entre páginas con la estrella KISMET ---------- */
(function () {
var L = document.querySelector('[data-kx-loader]');
if (!L) return;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
window.addEventListener('pageshow', function (e) { if (e.persisted) L.classList.remove('is-leaving'); });
if (reduce) return;
document.addEventListener('click', function (e) {
if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
var a = e.target.closest('a[href]'); if (!a) return;
if (a.target && a.target !== '_self') return;
if (a.hasAttribute('download') || a.hasAttribute('data-open') || a.hasAttribute('data-no-transition')) return;
var href = a.getAttribute('href');
if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
if (url.origin !== location.origin) return;
if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
if (/\/(cart|checkout|checkouts|account)/.test(url.pathname) && a.closest('[data-drawer]')) return;
e.preventDefault();
L.classList.add('is-leaving');
setTimeout(function () { location.href = url.href; }, 420);
});
})();